import { baseUrl } from './util';
import request from '@/utils/request';
import { setLocaleQuery } from '@/utils';

// 获取查询shopify产品数据接口
export const getIsAdvancedPurchase = (locale: string) => {
    return request.get(`${baseUrl(locale)}/customizeBundle/getIsAdvanced${setLocaleQuery(locale)}`);
};
